export const ItemTypes = {
  PROP: "prop"
};
